import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["large"]

  connect() {
    if (this.largeTarget.complete && this.largeTarget.naturalWidth > 0) {
      this.reveal()
    }
  }

  reveal() {
    this.largeTarget.classList.remove("opacity-0")
    this.largeTarget.classList.add("opacity-100")
  }
}
